import { showNotification } from '@mantine/notifications';
import axios from 'axios';
import { useEffect, useRef, useState } from 'react';
import { useApp } from '../contexts/app.context';
import { GENERATE_SIGN_UPLOAD_FILE } from '../services/files';

export const useFileUploader = ({ file, onFileUploaded }: any) => {
    const [error, setError] = useState<string>();
    const [fileSize, setFileSize] = useState<number>(0);
    const [serverProgress, setServerProgress] = useState(0);
    const [awsProgress, setAwsProgress] = useState(0);
    const [progress, setProgress] = useState(0);
    const [fileId, setFileId] = useState(null);
    const [filename, setFilename] = useState("Novo arquivo");
    const [fileType, setFileType] = useState("image");

    const { socket } = useApp();

    const widthRef = useRef<number>();
    const heightRef = useRef<number>();
    const sizeRef = useRef<number>();
    const durationRef = useRef<number>();

    const getOthers = () => {
        return {
            width: widthRef.current,
            height: heightRef.current,
            size: sizeRef.current,
            duration: durationRef.current,
        }
    }

    const getFileType = (type: string) => {
        type = type ?? "";
        let fieldType = "document";
        if (type.includes("image")) fieldType = "image";
        if (type.includes("video")) fieldType = "video";
        if (type.includes("audio")) fieldType = "audio";
        return fieldType;
    }

    const signUpload = (file: any, params: {
        size,
        filename,
        contentType,
        mimetype,
    }) => {
        GENERATE_SIGN_UPLOAD_FILE(params)
            .then(res => {
                axios.put(res.signedUrl, file, {
                    headers: { 'Content-Type': file.type },
                    onUploadProgress: (progressEvent) => {
                        const totalLength = progressEvent.lengthComputable ? progressEvent.total : progressEvent.target.getResponseHeader('content-length') || progressEvent.target.getResponseHeader('x-decompressed-content-length');
                        if (totalLength !== null) {
                            setServerProgress(Math.round((progressEvent.loaded * 100) / totalLength));
                            setAwsProgress(Math.round((progressEvent.loaded * 100) / totalLength));
                        }
                    },
                })
                    .then(() => {
                        onFileUploaded({ url: res.generatedUrl, type: getFileType(params.contentType), ...getOthers() })
                        // FILE_UPLOADED(res.id, { url: res.generatedUrl })
                        //     .then(() => { })
                        //     .catch(err => {
                        //         showNotification({ message: err.message, color: "red" })
                        //     })
                    })
                    .catch(err => {
                        setError(err.message);
                        showNotification({ message: err.message, color: "red" })
                    })
            })
            .catch(err => {
                setError(err.message);
                showNotification({ title: "Falha ao salvar arquivo", message: err.message, color: 'red' })
            })
    }

    const handleInsertFile = async (file: any) => {
        try {
            setFilename(file.name);
            console.log(file);
            let fieldType = getFileType(file.type);
            setFileType(fieldType);
            setFileSize(file.size);
            if (file.size > 512000000) throw new Error("Maximum file size is 50GB");


            if (fieldType === "video") {
                await new Promise((resolve, reject) => {
                    const video = document.createElement("video");
                    video.preload = "metadata";

                    video.onloadedmetadata = () => {
                        window.URL.revokeObjectURL(video.src);
                        const width = video.videoWidth;
                        const height = video.videoHeight;
                        const duration = video.duration;

                        widthRef.current = width;
                        heightRef.current = height;
                        sizeRef.current = file.size;
                        durationRef.current = duration;

                        // alert(JSON.stringify({
                        //     widthRef: widthRef.current,
                        //     heightRef: heightRef.current,
                        //     sizeRef: sizeRef.current,
                        //     durationRef: durationRef.current,
                        // }))
                        // if (width > 1920 || height > 1080) {
                        //     reject(new Error(`Vídeo com resolução muito grande - ${width} x ${height}px`));
                        // } else if (duration > 90) {
                        //     reject(new Error(`Vídeo muito longo (${Math.ceil(duration)} segundos), máximo permitido: 90s`));
                        // } else {
                        resolve(true);
                        // }
                    };

                    video.onerror = () => {
                        reject(new Error("Failed to load video data."));
                    };

                    video.src = URL.createObjectURL(file);
                });
            }

            signUpload(file, {
                size: file.size,
                filename: file.name,
                contentType: file.type,
                mimetype: file.type,
            })
        } catch (err: any) {
            setError(err.message);
            showNotification({ message: err.message, color: "red" })
        }
    }

    useEffect(() => { setProgress(awsProgress) }, [serverProgress, awsProgress]);


    useEffect(() => {
        handleInsertFile(file);
    }, [file]);

    return {
        name: filename,
        type: fileType,
        progress,
        error,
        size: fileSize,
    };
}